import React, { useState, useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate, Link } from 'react-router-dom';

function ProfilePage({ user, userData }) {
    const navigate = useNavigate();
    const teamId = userData?.teamId;
    const [teamData, setTeamData] = useState(null);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!teamId) return;
        const fetchTeam = async () => {
            const snap = await getDoc(doc(db, 'teams', teamId));
            if (snap.exists()) setTeamData(snap.data());
        };
        fetchTeam();
    }, [teamId]);

    const handleLogout = async () => {
        await signOut(auth);
        navigate('/login');
    };

    const handleCopyCode = () => {
        if (teamData?.inviteCode) {
            navigator.clipboard.writeText(teamData.inviteCode);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    return (
        <div className="page-container mobile-page">
            <div className="mobile-page-header">
                <h1 className="mobile-page-title">👤 Профайл</h1>
            </div>

            <div className="glass-card profile-card">
                {user?.photoURL && (
                    <img src={user.photoURL} alt="Profile" className="profile-avatar" />
                )}
                <h2 className="profile-name">{user?.displayName}</h2>
                <p className="profile-email">{user?.email}</p>
                <div className="profile-badges">
                    <span className="badge badge-user">
                        <span className="badge-dot"></span>
                        {userData?.teamRole === 'owner' ? 'Эзэмшигч' : userData?.teamRole === 'admin' ? 'Админ' : 'Гишүүн'}
                    </span>
                </div>
            </div>

            {/* Team Info */}
            {teamId && (
                <div className="glass-card" style={{ marginBottom: '1rem', padding: '1.2rem' }}>
                    <h3 style={{ marginBottom: '0.75rem', fontSize: '0.95rem' }}>🏢 Багийн мэдээлэл</h3>
                    <div style={{ marginBottom: '0.5rem' }}>
                        <span style={{ color: 'var(--text-muted)', fontSize: '0.8rem' }}>Нэр: </span>
                        <span style={{ fontWeight: 600 }}>{teamData?.name || 'Тохируулаагүй'}</span>
                    </div>
                    <div style={{ marginBottom: '0.5rem' }}>
                        <span style={{ color: 'var(--text-muted)', fontSize: '0.8rem' }}>Гишүүд: </span>
                        <span style={{ fontWeight: 600 }}>{teamData?.memberCount || '—'}</span>
                    </div>
                    {teamData?.inviteCode && (
                        <>
                            <div style={{ marginBottom: '0.75rem' }}>
                                <span style={{ color: 'var(--text-muted)', fontSize: '0.8rem' }}>Урилга код: </span>
                                <span style={{
                                    fontWeight: 700, fontSize: '1.2rem', letterSpacing: '0.15rem',
                                    background: 'var(--accent-gradient)', WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent', backgroundClip: 'text'
                                }}>
                                    {teamData.inviteCode}
                                </span>
                            </div>
                            <button className="btn btn-secondary" onClick={handleCopyCode}
                                style={{ width: '100%', padding: '0.6rem' }}>
                                {copied ? '✅ Хуулагдсан!' : '📋 Урилга код хуулах'}
                            </button>
                            <p style={{ color: 'var(--text-muted)', fontSize: '0.7rem', marginTop: '0.5rem', textAlign: 'center' }}>
                                Энэ кодыг бусдад өгч багтаа урина уу
                            </p>
                        </>
                    )}
                    {!teamData && (
                        <p style={{ color: 'var(--text-muted)', fontSize: '0.75rem', marginTop: '0.5rem' }}>
                            ⚠️ Админ хуудаснаас Migration ажиллуулж data шилжүүлнэ үү
                        </p>
                    )}
                </div>
            )}

            <div className="glass-card" style={{ padding: '1rem' }}>
                {(userData?.teamRole === 'owner' || userData?.teamRole === 'admin' || userData?.role === 'admin') && (
                    <Link to="/admin" className="btn btn-secondary" style={{ width: '100%', marginBottom: '0.75rem', display: 'block', textAlign: 'center' }}>
                        ⚙️ Админ удирдлага
                    </Link>
                )}
                <button onClick={handleLogout} className="btn btn-danger" style={{ width: '100%' }}>
                    🚪 Гарах
                </button>
            </div>
        </div>
    );
}

export default ProfilePage;
